import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
export var useRecordsLimit = function () {
    var ky = useOkapiKy();
    var data = useQuery({
        queryKey: ['refreshLimit'],
        queryFn: function () { return ky.get('lists/configuration').json(); },
        retry: false,
        refetchInterval: false,
        select: function (_a) {
            var maxListSize = _a.maxListSize;
            return maxListSize;
        }
    }).data;
    return data;
};
